export const frommHabenSeinFAQ = [
  {
    question: 'Ist "Die Kunst des Liebens" ein Beziehungsratgeber?',
    answer: 'Nein. Fromm schreibt über Liebe als philosophisches Prinzip, nicht als romantische Emotion. Das Buch behandelt brüderliche, mütterliche, erotische, Selbst- und Gottesliebe – nicht nur Partnerschaft.'
  },
  {
    question: 'Was bedeutet "Haben oder Sein" praktisch für mein Business?',
    answer: 'Haben-Modus: "Ich muss 50 Kunden haben, 10.000 Follower haben, eine Million Umsatz haben." Sein-Modus: "Ich schaffe Räume für Wachstum, ich bin präsent, ich praktiziere Wertschöpfung." Die Frage ist: Definierst du dich über Besitz (fragil, nie genug) oder über Praxis (resilient, erfüllend)?'
  },
  {
    question: 'Ist Selbstliebe nicht egoistisch?',
    answer: 'Fromm sagt: Nein. Egoismus ist das Gegenteil von Selbstliebe. "Der Egoist liebt sich nicht zu sehr, sondern zu wenig; in Wirklichkeit hasst er sich." Selbstliebe = sich selbst mit denselben Prinzipien begegnen wie anderen (Fürsorge, Respekt, Erkenntnis).'
  },
  {
    question: 'Fromm schreibt von "Gottesliebe" – ist das religiös?',
    answer: 'Nicht dogmatisch. Fromm (humanistischer Psychoanalytiker) meint: Ehrfurcht vor dem Leben, Verbundenheit mit etwas Größerem. Gottesliebe = nicht passives Glauben, sondern aktive Praxis der Transzendenz (über sich hinauswachsen).'
  },
  {
    question: 'Welches Buch soll ich zuerst lesen?',
    answer: '"Die Kunst des Liebens" (1956): Wenn du verstehen willst, was Liebe wirklich bedeutet. "Haben oder Sein" (1976): Wenn du verstehen willst, wie du lebst (und ob du es ändern willst). Beide ergänzen sich. Fromm selbst sah "Haben oder Sein" als Weiterentwicklung seiner früheren Thesen.'
  }
];
